import { ApolloClient, ApolloLink, from, HttpLink, InMemoryCache } from "@apollo/client";
import { addAuthorizationToExtensions, createHttpAuthLink } from "./auth";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

const cache = new InMemoryCache();
const httpLink = new HttpLink({
    uri: window.chattoBaseUrl + "/graphql",
});

const wsLink = new GraphQLWsLink(
    createClient({
        url: window.chattoBaseUrl.replace("http", "ws") + "/ws-graphql",
        lazy: true,
    })
);

// TODO: handle errors!

export const chattoClients = {
    http: new ApolloClient({
        cache,
        link: from([createHttpAuthLink(), httpLink]),
    }),
    ws: new ApolloClient({
        cache,
        link: from([new ApolloLink(addAuthorizationToExtensions), wsLink]),
    }),
};
